if (!customElements.get('ht-sticky-purchase')) {
  customElements.define('ht-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.source = document.getElementById(`MainProduct-${this.dataset.section}`);
      if (!this.source) return;
      this.button = this.querySelector('[data-ht-sticky-button]');
      this.price = this.querySelector('[data-ht-sticky-price]');
      this.mobile = matchMedia('(max-width: 749px)');
      this.sync = this.sync.bind(this);
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
      };
      this.onClick = () => {
        const original = this.source.querySelector('product-form button[name="add"]');
        if (!original || original.disabled || original.getAttribute('aria-disabled') === 'true') return;
        original.click();
        this.sync();
      };
      this.button.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(this.onScroll);
      this.observer.observe(this.source, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden'] });
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.mobile.addEventListener('change', this.sync);
      this.sync();
    }
    sync() {
      const original = this.source.querySelector('product-form button[name="add"]');
      const error = this.source.querySelector('.product-form__error-message-wrapper');
      const hasError = error && !error.hidden && error.textContent.trim();
      this.hidden = !original || !this.mobile.matches || original.getBoundingClientRect().bottom > 0 || Boolean(hasError);
      if (!original) return;
      this.button.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
      this.button.textContent = original.querySelector('span:not(.loading__spinner)')?.textContent.trim() || original.textContent.trim();
      const priceBox = document.getElementById(`price-${this.dataset.section}`);
      const sale = priceBox?.querySelector('.price--on-sale .price-item--sale');
      const regular = priceBox?.querySelector('.price__regular .price-item--regular');
      this.price.textContent = (sale || regular)?.textContent.trim() || '';
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.mobile?.removeEventListener('change', this.sync);
      this.button?.removeEventListener('click', this.onClick);
    }
  });
}
